// @ts-ignore
import { FC } from 'react'
// @ts-ignore
import React from 'react'
// @ts-ignore
import { LinkButton } from './LinkButton.tsx'
import styles from './projectCard.module.scss'

interface ProjectCardProps {
  title: string
  description: string
  image: string
  GitHub: string
  hosted: string
  tags: Array<String>
}

const ProjectCard: FC<ProjectCardProps> = (props) => {
  return (
    <div className={styles.projectCard}>
      <div className={styles.imagewrapper}>
        <img src={props.image} alt={props.title} />
      </div>
      <div className={styles.content}>
        <h2>{props.title}</h2>
        <p>{props.description}</p>
        <div className={styles.buttons}>
          {props.GitHub && <LinkButton isGitHub={true} link={props.GitHub} />}
          {props.hosted && <LinkButton isGitHub={false} link={props.hosted} />}
        </div>
        <div className={styles.buttons}>{props.tags}</div>
      </div>
    </div>
  )
}

export { ProjectCard }
